import { HttpParams } from '@angular/common/http';
import { typedEntries } from './typed-entries';
import { SfSelectOption } from 'ngx-smart-form';

type ParamsObject = Record<string, string | boolean | number | object | null>;

export const genHttpParams = <P extends ParamsObject>(filter?: P) => {
  if (!filter) {
    return new HttpParams();
  }
  let entries = typedEntries<ParamsObject>(filter);
  let params = new HttpParams();
  entries.forEach(([key, value]) => {
    /* if (key === 'statiPratica' && value && Array.isArray(value)) {
      value.forEach((el) => {
        params = params.set(key, el);
      });
    } else */ if ((value || value === 0) && key !== 'piva') {
      let newParamValue = '';
      if (typeof value === 'string') {
        newParamValue = value;
      } /* else if (Array.isArray(value)) {
        newParamValue = `[${value.join(',')}]`;
      } */ else {
        newParamValue = value.toString();
      }
      params = params.set(key, newParamValue);
    }
  });
  return params;
};

export const addEmptyOption = <T>(
  options: SfSelectOption<T | null>[],
  withEmptyOption: boolean
) => {
  const additionalItems: SfSelectOption<T | null>[] = withEmptyOption
    ? [
        {
          value: null,
          view: '---',
        },
      ]
    : [];
  const optionsCopy: SfSelectOption<T | null>[] = [
    ...additionalItems,
    ...options,
  ];
  return optionsCopy;
};
